import React, { Component } from 'react';
import classNames from 'classnames';

export default class PromotionCopy extends Component {
  render() {
    const {
      tag: Tag,
      className,
      copy,
      couponCode,
      tiersHighlightColor,
    } = this.props;

    const backgroundColor = tiersHighlightColor?.css || 'unset';

    // eslint-disable-next-line no-underscore-dangle
    const __html = copy?.replace('$code', `<span class="promotion-copy__code" style="background-color: ${backgroundColor}">${couponCode}</span>`);

    return (
      <Tag
        className={classNames('promotion-copy', className)}
        dangerouslySetInnerHTML={{ __html }}
      />
    );
  }
}
